<template>
    <div>
        <div v-show="!loading">
            <div v-html="svg_loaded" class="text-center"></div>

            <template v-if="!loading">
                <template
                    v-if="! seccion.tiene_secciones && load_popover"
                >
                    <PopOverComponent
                        v-for="zona in zonas"
                        :key="zona.id" 
                        :zona="zona" 
                        :zona_id="zona_id" 
                        :libres="getAsientosLibres(zona)" 
                        :occupied="zona.id === zona_id"
                    />
                </template>                
                <b-popover v-else-if="load_popover" v-for="zona in zonas" :key="zona.id" :target="'popover-' + zona.id" triggers="hover focus">
                    <template slot="title">{{ zona.name }}</template>
                    <span v-if="!zona.esta_disponible && zona.tiene_precios">{{ $t('partidos.agotadas') }}</span>
                    <span v-else-if="!zona.esta_disponible && !zona.tiene_precios">{{ $t('mapa.no_disponible') }}</span>
                </b-popover>
            </template>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 400px">
                <LoaderComponent/>
            </div>
        </template> 
    </div>
</template>

<script>
    import PopOverComponent from '@/components/svg/components/PopOverComponent.vue';

    export default {
        components: {PopOverComponent},
        props: ['zonas', 'event', 'sesion_id', 'zona_id', 'seccion'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                reg: null,
                load_popover: true
            }            
        },
        created() {
            this.getSvgCode();  

        
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if(/windows phone/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/android/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.load_popover = false;
            }
        },
        watch: {
            // La lista llega en su propia petición: al cambiar hay que volver a colorear y
            // enganchar el click de lo que aparezca más tarde que el SVG.
            zonas() {
                this.pintarRegiones();
            },
        },

        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods : {
            getAsientosLibres(zona) {
                if(zona.libres >= 0) {
                    return zona.libres;
                }

                if(zona.libres < 0) {
                    return 0;
                }

                var aforo = 0;

                if(!zona.with_seats) {
                    aforo = zona.aforo;
                } else {
                    aforo = zona.total_asientos;
                }

                aforo = aforo - zona.confirmados - zona.bloqueados - zona.no_confirmados - zona.sesion;

                if(aforo < 0) {
                    aforo = 0;
                }

                return aforo;
            },
            getSvgCode() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    tid: this.configuracion.hash_teatro,
                    event_id: this.event.id,
                    sesion_id: this.sesion_id,
                    seccion_id: this.seccion.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.secciones.seccion.svg'), params).then(res => {
                    this.loadSVG(res.data.svg);
                });
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                // El SVG se inyecta con `v-html`: basta con esperar a que Vue lo pinte para poder
                // colorear sus zonas. Antes había un setTimeout(1000) fijo, que dejaba el mapa
                // a la vista un segundo entero sin colorear (se veía "vacío y luego se rellenaba").
                this.$nextTick(() => {
                    this.pintarRegiones();

                    this.loading = false;
                    this.$emit('cargado');
                });                
            },
            /**
             * Colorea las regiones y engancha su click.
             *
             * Se llama al pintar el SVG y cada vez que cambian las zonas: el SVG de la sección y
             * su lista de regiones son dos peticiones distintas, así que las regiones pueden
             * llegar después del primer barrido. Antes el click se enganchaba sólo en ese primer
             * barrido, y la región que llegaba más tarde se quedaba muerta en el mapa mientras la
             * tabla de la derecha seguía funcionando (su @click lo pone Vue).
             */
            pintarRegiones() {
                var regions = document.getElementsByClassName("recinto-zona");
                var vue_instance = this;

                this.reg = regions;

                for(var i in regions) {
                    if(regions[i].dataset !== undefined) {
                        var region_id = regions[i].dataset.region;

                        for(var j in this.zonas) {
                            if(this.zonas[j].id == region_id && !this.zonas[j].esta_disponible) {
                                regions[i].classList.add("plaza_ocupada");
                            }
                        }

                        // El click va siempre y una sola vez por elemento: quién puede entrar lo
                        // decide `clickRegion`, no este barrido.
                        if (!regions[i].dataset.regionClick) {
                            regions[i].dataset.regionClick = "1";
                            regions[i].addEventListener('click', function() {
                                vue_instance.clickRegion(this.dataset.region);
                            }, false);
                        }
                    }
                }
            },

            clickRegion : function(region_id) {
                let zona = null;
                for(let i in this.zonas) {
                    if(this.zonas[i].id == region_id) {
                        zona = this.zonas[i];
                    }
                }

                if(zona) {
                    if(! this.seccion.tiene_secciones) {
                        if(this.can_click && zona.esta_disponible && this.getAsientosLibres(zona) > 0 && zona.precios.length > 0) {
                            this.$emit('clickZona', zona);
                        }

                        if(this.$route.name === 'back.events.sesion.bloquear-asientos' || this.$route.name === 'back.abonos.bloquear-asientos' || this.$route.name === 'back.abonos.index' || this.$route.name === 'back.abonados.show'  || this.$route.name === 'back.events.venta' || this.$route.name === 'superadmin.butacas.ocultar') {
                            this.$emit('clickZona', zona);
                        }
                    } else {
                        this.$emit('clickZona', zona);
                    }                
                }            
            }
        }
    }
</script>